<template>
	<div v-if="orderInfoData">
		<el-card>
			<div slot="header">
				<span>投保信息</span>
				<span style="float: right; font-weight: bold">
					保费合计：
					<span class="red-bold" style="font-size: 1.26em">{{ orderInfoData.totalPremium }}</span>
					元
				</span>
			</div>
			<template>
				<div v-if="!isMore">
					{{ getUnitTitle }}
					<span class="u-font-weight-bold">{{ unitName }}</span>
				</div>
				<div style="margin: 2px 0">
					保障时间：
					<span class="red-bold">{{ orderInfoData.effectiveDate }}</span>
					至
					<span class="red-bold">{{ orderInfoData.expiryDate }}</span>
				</div>
				<div v-if="!isAdd" style="margin-bottom: 10px">
					保障期限：
					<span class="red-bold">{{ getTermContent }}</span>
				</div>
				<div v-else style="margin-bottom: 10px">
					保障天数：
					<span class="red-bold">{{ orderInfoData.periodDay }} 天</span>
				</div>
			</template>
			<avue-crud ref="refInfo" :data="empsData" :option="confirmOption">
				<template #professionId="{row}">
					<span>{{ row.professionName }}</span>
				</template>
				<!--        <template slot="coverage">-->
				<!--          <span>{{ formSubmit.coverage }}万</span>-->
				<!--        </template>-->
				<!--        <template slot="remark" slot-scope="scope">-->
				<!--          <span style="color:red;font-weight:bold">{{ scope.row.remark }}</span>-->
				<!--        </template>-->
			</avue-crud>
		</el-card>
	</div>
</template>
<script>
export default {
	name: 'insureInfoConfirm',
	components: {},
	props: {
		orderInfoData: {
			type: Object,
			required: true,
			default: () => {
				return {}
			},
		},
		empsData: {
			type: Array,
			required: true,
			default: () => {
				return []
			},
		},
		isAdd: Boolean,
		isMore: Boolean,
		unitName: String,
		totalPremium: String | Number,
		actType: String,
	},
	data() {
		return {
			confirmOption: {},
		}
	},
	computed: {
		getUnitTitle() {
			return this.unitName && this.unitName.length > 5 ? '企业名称：' : '姓  名：'
		},
		getTermContent() {
			let {term = '', termUnit = ''} = this.orderInfoData
			return `${term}${termUnit === 'D' ? '天' : '个月'}`
		},
	},
	methods: {
		setOption(option) {
			if (this.validatenull(this.confirmOption)) {
				//处理option
				option.menu = false
				let tempIndex = 0
				option.column.forEach((itemData, index) => {
					let {prop = ''} = itemData
					itemData.$cellEdit = false
					itemData.cell = false
					if (prop === 'professionId') {
						itemData.prop = 'professionName'
						delete itemData.type
						tempIndex = index
					} else if (prop === 'empName' || prop === 'name') {
						itemData.width = 120
					} else if (prop === 'areaCode' || prop === 'addr') {
						itemData.hide = true
					} else if (prop === 'premium') {
						itemData.width = 120
						//删除悬浮
						delete itemData.fixed
					}
					if (prop === 'empName' || prop === 'empIdNo') {
						itemData.hide = false
					}
				})
				option.column.push({
					label: '备注',
					prop: 'remark',
					width: 120,
					html: true,
					formatter: ({remark = ''}) => {
						if (remark === '') {
							return ''
						}
						return '<span class="red-bold">' + remark + '</span>'
					},
				})
				option.column.splice(tempIndex + 1, 0, {label: '保额（万）', prop: 'amount', width: 120})
				this.confirmOption = option
			}
		},
		onRefreshTable() {
			this.$refs.refInfo.refreshTable()
		},
	},
}
</script>
